import { SecureComponent } from './secure/secure.component';
import { Component,EventEmitter, Output, OnChanges } from '@angular/core';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { Router, NavigationEnd } from '@angular/router';
import { IUser } from './shared/Domains/IUser';
import { ConfirmationService } from 'primeng/api';
import { Configuration } from 'config/config';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-inline-profile',
    template: `
        <div class="profile" [ngClass]="{'profile-expanded':active}">
            <a href="#" (click)="onClick($event)">
                <img class="profile-image" [src]="updateUserProfileImage()"
                style="border-radius: 50%;height: 180px;width: 180px;"/>
                <span class="profile-name">{{user.name}}</span>
                <i class="material-icons">keyboard_arrow_down</i>
            </a>
        </div>

        <ul class="ultima-menu profile-menu" [@menu]="active ? 'visible' : 'hidden'">
            <li role="menuitem">
                <a (click)="profile()" class="ripplelink" [attr.tabindex]="!active ? '-1' : null">
                    <i class="material-icons">person</i>
                    <span>Profile</span>
                </a>
            </li>
            <li role="menuitem">
                <a class="ripplelink" [attr.tabindex]="!active ? '-1' : null">
                    <i class="material-icons">language</i>
                    <p-dropdown [options]="languages" [(ngModel)]="selectedLanguages" optionLabel="name" optionValue="code" appendTo="body" placeholder="Select Language" (onChange)="langChange()" />
                </a>
            </li>
            <!--<li role="menuitem">
                <a routerLink="/settings/roles" class="ripplelink" [attr.tabindex]="!active ? '-1' : null">
                    <i class="material-icons">security</i>
                    <span>Privacy</span>
                </a>
            </li>
            <li role="menuitem">
                <a routerLink="/globals" class="ripplelink" [attr.tabindex]="!active ? '-1' : null">
                    <i class="material-icons">settings_application</i>
                    <span>Settings</span>
                </a>
            </li>-->
            <li role="menuitem">
                <a (click)="logout()" class="ripplelink" [attr.tabindex]="!active ? '-1' : null">
                    <i class="material-icons">power_settings_new</i>
                    <span>Logout</span>
                </a>
            </li>
        </ul>
    `,
    animations: [
        trigger('menu', [
            state('hidden', style({
                height: '0px'
            })),
            state('visible', style({
                height: '*'
            })),
            transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppInlineProfileComponent {
    user: IUser;
    active: boolean;
    lang:string  = 'en';
    languages = [];
    selectedLanguages = "";
    private routeSubscription: Subscription;

    constructor(private route: Router, public app: SecureComponent, public ConfirmationService: ConfirmationService, public config: Configuration) {
        this.user = JSON.parse(localStorage.getItem('currentUser'));
        let lang = localStorage.getItem('Lang');
        if (!lang) {
            localStorage.setItem('Lang', "en");
            this.selectedLanguages = "en"; // default language is English
        }
       else if(lang == "ar") {
            this.lang = "ar";
            this.selectedLanguages = this.lang;
            let bodyElement = document.getElementsByTagName("body")[0];
            bodyElement.setAttribute("class", "leftToRight");
            bodyElement.setAttribute("dir", "rtl");
        }
        else if(lang == "ur") {
            this.lang = "ur";
            this.selectedLanguages = this.lang;
            let bodyElement = document.getElementsByTagName("body")[0];
            bodyElement.setAttribute("class", "leftToRight");
            bodyElement.setAttribute("dir", "rtl");
        }
        else if(lang == "ps") {
            this.lang = "ps";
            this.selectedLanguages = this.lang;
            let bodyElement = document.getElementsByTagName("body")[0];
            bodyElement.setAttribute("class", "leftToRight");
            bodyElement.setAttribute("dir", "rtl");
        }
        else {
            let bodyElement = document.getElementsByTagName("body")[0];
            bodyElement.removeAttribute("dir");
            bodyElement.classList.remove("leftToRight");
            this.selectedLanguages = "en";
        }
    }
    ngOnInit(): void {

        this.languages.push({name: "English", code: "en"});
        this.languages.push({name: "عربي", code: "ar"});
        this.languages.push({name: "اردو", code: "ur"});
        this.languages.push({name: "پشتو", code: "ps"});
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
        this.routeSubscription = this.route.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // Specify the routes where you want to update the user profile image
                const allowedRoutes = ['/members'];
                // Check if the current route is in the allowed routes
                const currentRoute = this.route.routerState.snapshot.url;
                if (allowedRoutes.includes(currentRoute)) {
                    this.updateUserProfileImage();
                }
                // Perform refresh tasks here
                // This code will run every time a navigation ends,
                // including when you navigate to the 'members' route
            }
        });
    }

    // getOtherLang() {
    //     if(this.lang === "en") {
    //         return  "عربي" + "Urdu"
    //         // return "Urdu";
    //     }
    //     else if(this.lang === "ar") {
    //         return "English" + "Urdu";
    //     }
    //     else if(this.lang === "ur") {
    //         return "English" + "عربي";
    //         // return "عربي";

    //     }
    // }
    // getOtherLang() {
    //     switch (this.lang) {
    //       case "en":
    //         return {"عربي" : "عربي","Urdu" : "Urdu"};
    //       case "ar":
    //         return {"English" : "English" ,"Urdu" : "Urdu"};
    //       case "ur":
    //         return {"English" : "English" ,"عربي" : "عربي" };
    //       default:
    //         return {};
    //     }
    //   }
    langChange() {
        if(this.selectedLanguages === "en") {
            localStorage.setItem('Lang', "en");
        }
        else if(this.selectedLanguages === "ar") {
            localStorage.setItem('Lang', "ar");
        }
        else if(this.selectedLanguages === "ur") {
            localStorage.setItem('Lang', "ur");
        }
        else if(this.selectedLanguages === "ps") {
            localStorage.setItem('Lang', "ps");
        }
        window.location.reload();
    }

    updateUserProfileImage(): string {
        this.config.userImagePath = localStorage?.getItem('userImagePath');
        return this.config.Server + this.config.userImagePath + this.user.profile;
    }

    onClick(event) {
        this.active = !this.active;
        setTimeout(() => {
            this.app.layoutMenuScrollerViewChild.moveBar();
        }, 450);
        event.preventDefault();
    }
    logout() {
        if (this.app.staticMenuMobileActive) {
            this.app.staticMenuMobileActive = false;   // Reset mobile menu
        }
        this.ConfirmationService.confirm({
            message: "Are you sure you want to Logout?",
            accept: () => {
                this.app.staticMenuMobileActive = true;
                localStorage.clear();
                this.route.navigateByUrl('/login');
            }
        });
    }
    
    profile() {
        this.route.navigateByUrl('/settings/user/' + this.user._id);
    }
}
